import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { CommonService } from './shared/services/commom.service';


const routes: Routes = [
    { path: 'home', loadChildren: './home/home.module#HomeModule' },
    { path: 'login', loadChildren: './login/login.module#LoginModule' },
    { path: 'registration', loadChildren: './registration/registration.module#RegistrationModule' },
    { path: 'guestuser', loadChildren: './guestuser/guestUser.module#GuestUserModule' },
    { path: 'emailverified', loadChildren: './email-verified/emailVerified.module#EmailVerifiedModule' },
    { path: "", redirectTo: 'home', pathMatch: 'full', canActivate: [CommonService] },
    { path: '**', redirectTo: 'not-found' },
    { path: 'verify-identity', loadChildren: './get-my-background-check/background-header/backgroundHeader.module#BackgroundHeaderProfileModule' },
    { path: 'background-login', loadChildren: './backgroundCheckLogin/backgroundCheckLogin.module#BackgroundCheckLoginModule' },
    { path: 'FeeApproval', loadChildren: './fee-approval/feeApproval.module#FeeApprovalModule' }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {

}